<template>
	<div class="flow-error-state-wrapper" :position="position">
		<div class="flow-error-state-icon-wrapper">
			<Icon :name="icon.name" :type="icon.type" size="large" :state="icon.state" :effects="false" />
		</div>
		<h3 v-if="message" class="fc-dark fw-normal flow-error-state-messsage text-wrap">
			{{ message }}
		</h3>
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon";

export default defineComponent({
	name: "ErrorState",
	components: {
		Icon
	},
	props: {
		icon: {
			type: Object,
			default: () => {
				return {
					name: "warning",
					type: "filled",
					state: "error"
				};
			}
		},
		position: {
			type: String,
			default: "relative"
		},
		message: {
			type: String,
			default: null
		}
	}
});
</script>
<style lang="scss">
div.flow-error-state-wrapper {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	height: 100%;

	> * {
		margin-bottom: 24px;
		&:last-child {
			margin-bottom: 0px;
		}
	}

	&[position="absolute"] {
		position: absolute;
		top: 0px;
		left: 0px;
		bottom: 0px;
		right: 0px;
	}

	> div.flow-error-state-icon-wrapper {
		display: flex;
		height: 72px;
		width: 72px;
		align-items: center;
		justify-content: center;
		background-color: var(--dashboard-element-light);
		border-radius: 36px;
	}

	> .flow-error-state-messsage {
		width: 200px;
		text-align: center;
	}

	.paragraph-1 {
		line-height: 24px;
	}
}
</style>
